
    <div style="padding: 2em">
    <h1 mat-dialog-title style="text-align: center;
    font-size: 2em;
    color: #4f4f4f;">Total Duct Leakage Missing</h1>
    <div>
      <p style="font-size: 1.5em;
      color: #424242;">This HVAC Grading (HVG) job is missing Total Duct Leakage (DB Total) for one or more systems. Please enter the total duct leakage on the Testing tab, or re-test if the house was not tested at rough-in.</p>
      <p style="font-size: 1.15em;
      color: #b71c1c;
      white-space: pre-line;">{{ data }}</p>
    </div>
    <div style="margin: auto;
    padding-left: 25%;
    padding-right: 25%;
    padding-top: 2em;">
      <button mat-button [mat-dialog-close]="1"  style="margin-right: 2em; height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Close Anyway</button>
      <button mat-button [mat-dialog-close]="2"  style="    height: 4em;
      background: #ffffffaf;
      width: 10em;
      font-size: 1em;">Back To Form</button>
    </div>
    </div>
  